var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowsLeft = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.615 6.146a.437.437 0 0 0-.653 0l-5.077 5.5a.53.53 0 0 0 0 .707l5.077 5.5c.18.196.473.196.653 0a.53.53 0 0 0 0-.707L9.865 12l4.75-5.147a.53.53 0 0 0 0-.707"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowsLeft);
export default ForwardRef;